<template>
  <div>
    <BlockUI v-if="loading"></BlockUI>
    <TituloComponent
      icono-titulo="fas fa-users"
      texto-titulo="Listado de clientes"
      :to-create-action="{name:'NuevoCliente'}"
      to-create-text="Nuevo cliente"
    ></TituloComponent>
    <div class="main-card mb-3 card col-12">
      <div class="card-body">
        <DataList  ref="datatable" url="/clientes" :fields="fields" :rowClick="verCliente" :toCuil="toCuil" :toPesos="toPesos"></DataList>
      </div>
    </div>
  </div>
</template>
<script>
import TituloComponent from "@/components/layouts/TituloComponent";
import DataList from "@/components/layouts/DataList";
import BlockUI from "@/components/loaders/BlockUI";
import Swal from "sweetalert2";
import axios from "axios";
export default {
  name: "ListarClientes",
  components: {
    TituloComponent,
    DataList,
    BlockUI
  },
  data() {
    return {
      fields: [
        {
          name: "codigo",
          label: "Código",
          type: "title",
          class: "",
          append: ' - '
        },
        {
          name: "nombre",
          label: "Nombre",
          type: "title",
          class: "text-success"
        },
        {
          name: "numero_documento",
          label: "N° documento",
          type: "field",
          class: "text-alternate",
        },
        {
          name: "domicilio",
          label: "Domicilio",
          type: "field",
          class: ""
        },
        {
          name: "localidad",
          label: "Localidad",
          type: "field",
          class: ""
        },
        {
          name: "codigo_postal",
          label: "CP",
          type: "field",
          class: ""
        },
        {
          name: "telefono",
          label: "Teléfono",
          type: "field",
          class: ""
        },
        {
          name: "responsabilidad_iva.descripcion",
          label: "IVA",
          type: "field",
          class: ""
        },
        {
          name: "dia_visita",
          label: "Día de visita",
          type: "field",
          class: "text-info"
        }
      ],
      toCuil:['numero_documento'],
      toPesos: ['saldo'],
      loading: false
    };
  },
  methods: {
    verCliente(cliente){
      this.$router.push({name:'VerCliente', params:{id:cliente.id}});
    },
    eliminarCliente(cliente) {
      Swal.fire({
        title: "¿Estás seguro?",
        text: `¿Deseas eliminar ${cliente.nombre} de manera permanente?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Eliminar",
        cancelButtonText: "Cancelar"
      }).then(result => {
        if (result.value) {
          this.loading = true;
          axios
            .delete("/clientes/" + cliente.id)
            .then(res => {
              Swal.fire(
                "Eliminado",
                `${res.data.cliente.nombre} se ha eliminado con éxito.`,
                "success"
              );
              this.$refs.datatable.update();
            })
            .catch(err => console.log(err))
            .finally(() => (this.loading = false));
        }
      });
    }
  }
};
</script>